<template>
  <div style="background-color: #F4FFFA;">
    <user-verified></user-verified>
    <the-navigation v-if="screenWidth > 600"></the-navigation>
    <div class="mainDashboard d-flex flex-column justify-content-between min-vh-100">
      <router-view></router-view>
    </div>
    <nav-mobile v-if="screenWidth <= 600"></nav-mobile>
  </div>
</template>

<script>
import Navigation from "../components/templates/Navigation/Navigation.vue";
import CheckUserIsVerified from "../components/templates/Dashboard/user_verification/CheckUserIsVerified.vue";
import NavigationMobileView from "../components/templates/Navigation/NavigationMobileView.vue";
import router from "../router";
import { getCurrentBaseSlug, redirectToInstitutionSlug, setCachedInstitutionSlug } from "../utils/institutionUrl";

export default {
  async created() {
    await window.addEventListener("resize", this.handleResize);
    await this.handleResize();
    const token = localStorage.getItem("token");

    if (!token) {
      this.$store.dispatch("logoutUser");
      return;
    }

    // Fetch institutes if not already fetched - same guard Navigation.vue
    // uses, kept here too since this is the one mount point that's always
    // rendered regardless of screen width (Navigation itself is desktop-only,
    // NavigationMobileView takes over below 600px and never ran this check).
    if (this.$store.getters.getInstitutes.length == 0) {
      await this.$store.dispatch("setUpInstitutes");
    }

    // Bank requires the institution to be identifiable in the URL for the
    // whole session, not just fee payment - make sure the URL's slug always
    // matches the user's actual active institution. A mismatch (generic
    // root, bank's dummy slug, someone else's slug, or a stale one after
    // switching institutions) means one corrective full-page redirect; this
    // converges immediately since the new load will match on the next run.
    const activeSlug = this.$store.getters.getCurrentInstitution?.slug;
    if (activeSlug && getCurrentBaseSlug(router) !== activeSlug) {
      redirectToInstitutionSlug(activeSlug);
      return;
    }
    if (activeSlug) {
      setCachedInstitutionSlug(activeSlug);
    }
  },
  components: {
    "the-navigation": Navigation,
    "user-verified": CheckUserIsVerified,
    navMobile: NavigationMobileView,
  },
  data() {
    return {
      screenWidth: 0,
    };
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
  },
};
</script>
